import { Company, DomainEntitiesLicensesAllFeaturesTrialStatus } from 'shared/data/webApp/v2';

export const checkIsTrialActive = (company?: Company) => {
    return company?.allFeaturesTrialStatus === DomainEntitiesLicensesAllFeaturesTrialStatus.Active;
};
